import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  IconButton,
  TextField,
  Button,
  Pagination,
  CircularProgress,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { UrlApiEnvasado } from "../../../../../services/apirest";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import BusinessIcon from "@mui/icons-material/Business";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useFechas } from "../../../context/FechaContext";
import { esUsuarioVip } from "../../utils/accesoSucursales";

function InfoGlobal() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!esUsuarioVip()) {
      navigate("/sucursalesnetizar");
    }
  }, []);

  const {
    desdeButano,
    hastaButano,
    desdePropano,
    hastaPropano,
    setDesdeButano,
    setHastaButano,
    setDesdePropano,
    setHastaPropano,
  } = useFechas();

  const [desde, setDesde] = useState(desdeButano);
  const [hasta, setHasta] = useState(hastaButano);

  const [butanoGeneral, setButanoGeneral] = useState([]);
  const [propanoGeneral, setPropanoGeneral] = useState([]);
  const [butanoHipergas, setButanoHipergas] = useState([]);
  const [propanoHipergas, setPropanoHipergas] = useState([]);
  const [butanoAogas, setButanoAogas] = useState([]);
  const [propanoAogas, setPropanoAogas] = useState([]);
  const [cantVendidaHipergas, setCantVendidaHipergas] = useState([]);
  const [cantVendidaAogas, setCantVendidaAogas] = useState([])
  const [loadingButanoGeneral, setLoadingButanoGeneral] = useState(true);
  const [loadingPropanoGeneral, setLoadingPropanoGeneral] = useState(true);
  const [loadingButanoHipergas, setLoadingButanoHipergas] = useState(true);
  const [loadingPropanoHipergas, setLoadingPropanoHipergas] = useState(true);
  const [loadingButanoAogas, setLoadingButanoAogas] = useState(true);
  const [loadingPropanoAogas, setLoadingPropanoAogas] = useState(true);
  const [loadingCantVendidaHipergas, setLoadingCantVendidaHipergas] =
    useState(true);
  const [loadingCantVendidaAogas, setLoadingCantVendidaAogas] = useState(true);
  //FETCHS

    const obtenerButano = async () => {
    setLoadingButanoGeneral(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/empresabutano/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setButanoGeneral(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingButanoGeneral(false);
    }
  };

  const obtenerPropano = async () => {
    setLoadingPropanoGeneral(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/empresapropano/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setPropanoGeneral(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPropanoGeneral(false);
    }
  };

  const obtenerButanoHipergas = async () => {
    setLoadingButanoHipergas(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/empresabutanohiper/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setButanoHipergas(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingButanoHipergas(false);
    }
  };

  const obtenerPropanoHipergas = async () => {
    setLoadingPropanoHipergas(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/empresapropanohiper/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setPropanoHipergas(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPropanoHipergas(false);
    }
  };

  const obtenerButanoAogas = async () => {
    setLoadingButanoAogas(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/empresabutanonatural/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setButanoAogas(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingButanoAogas(false);
    }
  };

  const obtenerPropanoAogas = async () => {
    setLoadingPropanoAogas(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/empresapropanonatural/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setPropanoAogas(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPropanoAogas(false);
    }
  };

  const obtenerCantHipergas = async () => {
    setLoadingCantVendidaHipergas(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/cantidadgeneralvendidahiper/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setCantVendidaHipergas(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingCantVendidaHipergas(false);
    }
  };

  const obtenerCantAogas = async () => {
    setLoadingCantVendidaAogas(true);
    try {
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/cantidadgeneralvendidanatural/${desde} 00:00:00/${hasta} 23:59:59`
      );
      const data = await response.json();
      setCantVendidaAogas(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingCantVendidaAogas(false);
    }
  };

  useEffect(() => {
    obtenerButano();
    obtenerPropano();
    obtenerButanoHipergas();
    obtenerPropanoHipergas();
    obtenerButanoAogas();
    obtenerPropanoAogas();
    obtenerCantHipergas();
    obtenerCantAogas();
  }, []);

  const handleUpdate = () => {
    obtenerButano();
    obtenerPropano();
    obtenerButanoHipergas();
    obtenerPropanoHipergas();
    obtenerButanoAogas();
    obtenerPropanoAogas();
    obtenerCantHipergas();
    obtenerCantAogas();
  };

  // *****
  // Función para formatear precios
  const formatPrice = (price) => {
    return price ? `$${price.toFixed(2)}` : "$0.00";
  };
  // Calcular promedios generales
  // Promedio Butano
  const promedioButano =
    butanoHipergas[0] && butanoAogas[0]
      ? (butanoHipergas[0].precio_promedio_por_kilo *
          butanoHipergas[0].kilos_vendidos +
          butanoAogas[0].precio_promedio_por_kilo *
            butanoAogas[0].kilos_vendidos) /
        (butanoHipergas[0].kilos_vendidos + butanoAogas[0].kilos_vendidos)
      : butanoHipergas[0]?.precio_promedio_por_kilo ||
        butanoAogas[0]?.precio_promedio_por_kilo ||
        0;

  // Promedio Propano
  const promedioPropano =
    propanoHipergas[0] && propanoAogas[0]
      ? (propanoHipergas[0].precio_promedio_por_kilo *
          propanoHipergas[0].kilos_vendidos +
          propanoAogas[0].precio_promedio_por_kilo *
            propanoAogas[0].kilos_vendidos) /
        (propanoHipergas[0].kilos_vendidos + propanoAogas[0].kilos_vendidos)
      : propanoHipergas[0]?.precio_promedio_por_kilo ||
        propanoAogas[0]?.precio_promedio_por_kilo ||
        0;

  return (
    <div style={{ backgroundColor: "#d7d7d7" }}>
      <AppBar position="static" sx={{ backgroundColor: "#1F618D", position: "relative" }}>
  <Toolbar sx={{ minHeight: 64 }}>
    {/* Botón de volver a la izquierda */}
    <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
      <ArrowBackIcon />
    </IconButton>

    {/* Título absolutamente centrado */}
    <Typography
      variant="h6"
      sx={{
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        textAlign: "center",
        pointerEvents: "none", // Evita que el título intercepte clicks
      }}
    >
      Información de la Empresa
    </Typography>

    {/* Texto a la derecha */}
    <Typography
      variant="caption"
      sx={{ color: "#EAF2F8", fontStyle: "italic", marginLeft: "auto" }}
    >
      * Todos los precios están expresados sin impuestos
    </Typography>
  </Toolbar>
</AppBar>


      <Box sx={{ backgroundColor: "#fff", p: 3 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          mb={2}
        >
          <Grid item xs={12} md={3}>
            <TextField
              label="Desde"
              type="date"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#1F618D" },
                  "&:hover fieldset": { borderColor: "#1F618D" },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Hasta"
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#1F618D" },
                  "&:hover fieldset": { borderColor: "#1F618D" },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              onClick={handleUpdate}
              size="medium"
              fullWidth
              sx={{
                backgroundColor: "#1F618D",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#154360",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(31, 97, 141, 0.3)",
                },
                transition: "all 0.3s ease",
                height: "40px",
              }}
              startIcon={<RefreshIcon />}
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ mb: 3 }}>
          {/* Card Promedio Butano */}
          <Grid item xs={12} md={3}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                height: "100%",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <LocalFireDepartmentIcon
                    sx={{ color: "#FF6B35", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    PROMEDIO BUTANO
                  </Typography>
                </Box>

                {loadingButanoGeneral ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "120px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : (
                  <>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                      <Typography
                        variant="h4"
                        sx={{ color: "#1F618D", fontWeight: "bold" }}
                      >
                        {formatPrice(butanoGeneral[0]?.precio_promedio_por_kilo)}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "#7F8C8D", mt: 1 }}
                      >
                        Precio promedio por kg
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        mt: 3,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="body2" sx={{ color: "#7F8C8D" }}>
                          Máximo
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ color: "#27AE60", fontWeight: "500" }}
                        >
                          {butanoGeneral[0]
                            ? butanoGeneral[0].precio_maximo_por_kilo                               
                            : null}
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="body2" sx={{ color: "#7F8C8D" }}>
                          Mínimo
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ color: "#E74C3C", fontWeight: "500" }}
                        >
                          {butanoGeneral[0]
                            ? butanoGeneral[0].precio_minimo_por_kilo                               
                            : null}
                        </Typography>
                      </Box>
                    </Box>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Card Promedio Propano */}
          <Grid item xs={12} md={3}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                height: "100%",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <LocalFireDepartmentIcon
                    sx={{ color: "#FF8C42", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    PROMEDIO PROPANO
                  </Typography>
                </Box>

                {loadingPropanoGeneral ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "120px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : (
                  <>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                      <Typography
                        variant="h4"
                        sx={{ color: "#1F618D", fontWeight: "bold" }}
                      >
                        {formatPrice(propanoGeneral[0]?.precio_promedio_por_kilo)}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "#7F8C8D", mt: 1 }}
                      >
                        Precio promedio por kg
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        mt: 3,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="body2" sx={{ color: "#7F8C8D" }}>
                          Máximo
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ color: "#27AE60", fontWeight: "500" }}
                        >
                          {/* {propanoAogas[0] && propanoHipergas[0] ? 
                            formatPrice(Math.max(propanoAogas[0].precio_maximo_por_kilo, propanoHipergas[0].precio_maximo_por_kilo)) : 
                            "$0.00"} */}
                          {propanoGeneral[0]
                            ? propanoGeneral[0].precio_maximo_por_kilo                               
                            : null}
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="body2" sx={{ color: "#7F8C8D" }}>
                          Mínimo
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ color: "#E74C3C", fontWeight: "500" }}
                        >
                          {propanoGeneral[0]
                            ? propanoGeneral[0].precio_minimo_por_kilo                               
                            : null}
                        </Typography>
                      </Box>
                    </Box>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Card Hipergas */}
          <Grid item xs={12} md={3}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #FF6B35",
                height: "100%",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <BusinessIcon
                    sx={{ color: "#FF6B35", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#FF6B35",
                      fontWeight: "700",
                      fontSize: "1rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    HIPERGAS
                  </Typography>
                </Box>

                {loadingButanoHipergas || loadingPropanoHipergas ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "120px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#FF6B35" }} />
                  </Box>
                ) : (
                  <Box sx={{ mt: 2 }}>
                    <Box sx={{ mb: 3 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#7F8C8D", mb: 1 }}
                      >
                        Butano Promedio
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ color: "#1F618D", fontWeight: "bold" }}
                        >
                          {butanoHipergas[0]
                            ? formatPrice(
                                butanoHipergas[0].precio_promedio_por_kilo
                              )
                            : "$0.00"}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {butanoHipergas[0]
                              ? `${butanoHipergas[0].kilos_vendidos} kg`
                              : "0 kg"}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {butanoHipergas[0]
                              ? `${butanoHipergas[0].cantidad_garrafas_vendidas} envases`
                              : "0 envases"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#7F8C8D", mb: 1 }}
                      >
                        Propano Promedio
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ color: "#1F618D", fontWeight: "bold" }}
                        >
                          {propanoHipergas[0]
                            ? formatPrice(
                                propanoHipergas[0].precio_promedio_por_kilo
                              )
                            : "$0.00"}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {propanoHipergas[0]
                              ? `${propanoHipergas[0].kilos_vendidos} kg`
                              : "0 kg"}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {propanoHipergas[0]
                              ? `${propanoHipergas[0].cantidad_garrafas_vendidas} envases`
                              : "0 envases"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Card Aogas */}
          <Grid item xs={12} md={3}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #2ECC71",
                height: "100%",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <BusinessIcon
                    sx={{ color: "#2ECC71", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#2ECC71",
                      fontWeight: "700",
                      fontSize: "1rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    AOGAS
                  </Typography>
                </Box>

                {loadingButanoAogas || loadingPropanoAogas ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "120px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#2ECC71" }} />
                  </Box>
                ) : (
                  <Box sx={{ mt: 2 }}>
                    <Box sx={{ mb: 3 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#7F8C8D", mb: 1 }}
                      >
                        Butano Promedio
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ color: "#1F618D", fontWeight: "bold" }}
                        >
                          {butanoAogas[0]
                            ? formatPrice(
                                butanoAogas[0].precio_promedio_por_kilo
                              )
                            : "$0.00"}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {butanoAogas[0]
                              ? `${butanoAogas[0].kilos_vendidos} kg`
                              : "0 kg"}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {butanoAogas[0]
                              ? `${butanoAogas[0].cantidad_garrafas_vendidas} envases`
                              : "0 envases"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#7F8C8D", mb: 1 }}
                      >
                        Propano Promedio
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ color: "#1F618D", fontWeight: "bold" }}
                        >
                          {propanoAogas[0]
                            ? formatPrice(
                                propanoAogas[0].precio_promedio_por_kilo
                              )
                            : "$0.00"}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {propanoAogas[0]
                              ? `${propanoAogas[0].kilos_vendidos} kg`
                              : "0 kg"}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {propanoAogas[0]
                              ? `${propanoAogas[0].cantidad_garrafas_vendidas} envases`
                              : "0 envases"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* ********************************************************************* */}

      {/* Sección de Ventas por Producto */}
      <Grid container spacing={2} p={3} sx={{ background: "#fff" }}>
        {/* Card Hipergas Butano */}
        <Grid item xs={6}>
          <Card
            sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              borderLeft: "4px solid #FF6B35",
              height: "100%",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <LocalFireDepartmentIcon
                  sx={{ color: "#FF6B35", fontSize: 28, mr: 1 }}
                />
                <Typography
                  variant="h6"
                  sx={{ color: "#FF6B35", fontWeight: "700", fontSize: "1rem" }}
                >
                  HIPERGAS - CANTIDAD DE ENVASES VENDIDOS "BUTANO"
                </Typography>
              </Box>

              {loadingCantVendidaHipergas ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "120px",
                  }}
                >
                  <CircularProgress sx={{ color: "#FF6B35" }} />
                </Box>
              ) : (
                <Grid container spacing={1}>
                  {cantVendidaHipergas
                    .filter((p) => p.codigo_articulo?.startsWith("01"))
                    .map((producto, index) => (
                      <Grid item xs={4} key={`hipergas-butano-${index}`}>
                        <Box sx={{ textAlign: "center", p: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {producto.name}
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{ color: "#1F618D", fontWeight: "bold" }}
                          >
                            {producto.total_garrafas_vendidas}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Card Hipergas Propano */}
        <Grid item xs={6}>
          <Card
            sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              borderLeft: "4px solid #FF8C42",
              height: "100%",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <LocalFireDepartmentIcon
                  sx={{ color: "#FF8C42", fontSize: 28, mr: 1 }}
                />
                <Typography
                  variant="h6"
                  sx={{ color: "#FF8C42", fontWeight: "700", fontSize: "1rem" }}
                >
                  HIPERGAS - CANTIDAD DE ENVASES VENDIDOS "PROPANO"
                </Typography>
              </Box>

              {loadingCantVendidaHipergas ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "120px",
                  }}
                >
                  <CircularProgress sx={{ color: "#FF8C42" }} />
                </Box>
              ) : (
                <Grid container spacing={1}>
                  {cantVendidaHipergas
                    .filter((p) => p.codigo_articulo?.startsWith("02"))
                    .map((producto, index) => (
                      <Grid item xs={4} key={`hipergas-propano-${index}`}>
                        <Box sx={{ textAlign: "center", p: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {producto.name}
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{ color: "#FF6B35", fontWeight: "bold" }}
                          >
                            {producto.total_garrafas_vendidas}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Card Aogas Butano */}
        <Grid item xs={6}>
          <Card
            sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              borderLeft: "4px solid #2ECC71",
              height: "100%",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <BusinessIcon sx={{ color: "#2ECC71", fontSize: 28, mr: 1 }} />
                <Typography
                  variant="h6"
                  sx={{ color: "#2ECC71", fontWeight: "700", fontSize: "1rem" }}
                >
                  AOGAS - CANTIDAD DE ENVASES VENDIDOS "BUTANO"
                </Typography>
              </Box>

              {loadingCantVendidaAogas ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "120px",
                  }}
                >
                  <CircularProgress sx={{ color: "#2ECC71" }} />
                </Box>
              ) : (
                <Grid container spacing={1}>
                  {cantVendidaAogas
                    .filter((p) => p.codigo_articulo?.startsWith("01"))
                    .map((producto, index) => (
                      <Grid item xs={4} key={`aogas-butano-${index}`}>
                        <Box sx={{ textAlign: "center", p: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {producto.name}
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{ color: "#1F618D", fontWeight: "bold" }}
                          >
                            {producto.total_garrafas_vendidas}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Card Aogas Propano */}
        <Grid item xs={6}>
          <Card
            sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              borderLeft: "4px solid #27AE60",
              height: "100%",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <BusinessIcon sx={{ color: "#27AE60", fontSize: 28, mr: 1 }} />
                <Typography
                  variant="h6"
                  sx={{ color: "#27AE60", fontWeight: "700", fontSize: "1rem" }}
                >
                  AOGAS - CANTIDAD DE ENVASES VENDIDOS "PROPANO"
                </Typography>
              </Box>

              {loadingCantVendidaAogas ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "120px",
                  }}
                >
                  <CircularProgress sx={{ color: "#27AE60" }} />
                </Box>
              ) : (
                <Grid container spacing={1}>
                  {cantVendidaAogas
                    .filter((p) => p.codigo_articulo?.startsWith("02"))
                    .map((producto, index) => (
                      <Grid item xs={4} key={`aogas-propano-${index}`}>
                        <Box sx={{ textAlign: "center", p: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "#7F8C8D" }}
                          >
                            {producto.name}
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{ color: "#27AE60", fontWeight: "bold" }}
                          >
                            {producto.total_garrafas_vendidas}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default InfoGlobal;
